import locale_br from './pt_BR';
import locale_es from './es_ES';

const data = {
	'pt-BR': locale_br,
	es: locale_es
};

export default data;
